/**
 * Debug flags read from the URL query string. Zero-cost when disabled.
 *
 *   ?debug=notif                 → notification pipeline traces
 *   ?debug=notif,ws              → both notification + WebSocket traces
 *   ?debug=all                   → everything
 *
 * Cached at module load — flipping the URL requires a hard refresh, which
 * is the right ergonomic (no accidental logs in normal use).
 */
const parseFlags = () => {
    if (typeof window === "undefined") return new Set();
    try {
        const raw = new URLSearchParams(window.location.search).get("debug") || "";
        const parts = raw.split(",").map((s) => s.trim()).filter(Boolean);
        return new Set(parts);
    } catch { return new Set(); }
};

const _flags = parseFlags();

const on = (flag) => _flags.has("all") || _flags.has(flag);

/**
 * `debugLog("notif", "message.new received", payload)` — no-op unless the
 * matching debug flag is present in the URL. Prefixes all output with a
 * bright `[hub:{flag}]` tag so Eduardo can grep the console quickly.
 */
export const debugLog = (flag, ...args) => {
    if (!on(flag)) return;
    // eslint-disable-next-line no-console
    console.log(`%c[hub:${flag}]`, "color:#0F4C81;font-weight:bold", ...args);
};

/** True when the caller's flag is enabled. Used to gate expensive computation. */
export const debugEnabled = (flag) => on(flag);
